import { useMemo, useState } from 'react'
import { useApiListNodeUser, useApiListUserLogin } from '../../api-new/state/content'
import { ModalDialog } from '../component/modal-dialog'
import { TextFilter } from './text-filter'
import { ButtonPrimary } from '../component/button'

export const PermissionNodeUserModal = ({ target, nodeID, allowAdd, allowDelete, onClose, onClosed }) => {
  const [filter, updateFilter] = useState('')

  const apiListUserLogin = useApiListUserLogin()
  const apiListNodeUser = useApiListNodeUser()

  const filteredItems = useMemo(
    () => {
      let lowerFilter = filter.toLowerCase()
      return apiListUserLogin.items.filter(
        i => i.email.toLowerCase().includes(lowerFilter) || i.firstName.toLowerCase().includes(lowerFilter) || i.lastName.toLowerCase().includes(lowerFilter)
      )
    },
    [apiListUserLogin.items, filter]
  )

  const handleOpen = () => {
    updateFilter('')
    apiListUserLogin.get()
    apiListNodeUser.get(`${nodeID}/node`)
  }

  const handleClose = () => onClose && onClose()

  const handleAdd = async userID => {
    await apiListNodeUser.post({ nodeID: nodeID, userID: userID })
    await apiListNodeUser.get(`${nodeID}/node`)
  }

  const handleRemove = async userID => {
    await apiListNodeUser.delete(`${nodeID}/${userID}`)
    await apiListNodeUser.get(`${nodeID}/node`)
  }

  return (
    <ModalDialog target={target} header="Add User" fullScreen onOpen={handleOpen} onClose={onClosed}>
      <div className="d-flex flex-column h-100">
        <div>
          <TextFilter value={filter} onChange={updateFilter} />
        </div>
        <div className="flex-fill overflow-auto p-2">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 50 }} />
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {filteredItems.map((userLogin, i) =>
                  <Item
                    key={i}
                    userLogin={userLogin}
                    selectedNodeUsers={apiListNodeUser.items}
                    allowAdd={allowAdd}
                    allowDelete={allowDelete}
                    onAdd={handleAdd}
                    onRemove={handleRemove}
                  />
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="pt-1 border-top">
          <ButtonPrimary onClick={handleClose}>close</ButtonPrimary>
        </div>
      </div>
    </ModalDialog>
  )
}

const Item = ({ userLogin, selectedNodeUsers, allowAdd, allowDelete, onAdd, onRemove }) => {
  const isChecked = useMemo(() => selectedNodeUsers.findIndex(selectedNodeUser => selectedNodeUser.userID === userLogin.userID) !== -1, [
    userLogin,
    selectedNodeUsers
  ])

  const handleClick = () => {
    if (isChecked) {
      allowDelete && onRemove && onRemove(userLogin.userID)
    } else {
      allowAdd && onAdd && onAdd(userLogin.userID)
    }
  }

  return (
    <tr style={{ cursor: 'pointer' }} onClick={handleClick}>
      <td>
        <input className="form-check-input" type="checkbox" checked={isChecked} onChange={() => {}} />
      </td>
      <td>
        {userLogin.email}
      </td>
    </tr>
  )
}
